import React from 'react';
import PropTypes from 'prop-types';
import { PayloadStates } from '@lore/utils';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import Loader from '../../components/Loader';
import Offer from './DialogLayout';
import CloseDialogButton from '../../dialogs_common/CloseDialogButton';

OfferManageDialog.propTypes = {
  offer: PropTypes.object.isRequired
};

export default function OfferManageDialog(props) {
  const { offer } = props;

  if (offer.state === PayloadStates.FETCHING) {
    return (
      <DialogTemplate>
        <Loader />
      </DialogTemplate>
    );
  }

  return (
    <DialogTemplate className="w-screen max-w-screen-lg">
      <CloseDialogButton onCancel={props.onCancel} />
      <div className="px-6 pt-16 pb-6">
        <Offer
          offer={offer}
          onClose={props.onCancel}
        />
      </div>
    </DialogTemplate>
  );
};
